import store from '../configureStore';
import { convertObjectBodyString, apiGet, apiPost } from './apiUtil';

interface AddVideoTaskParams {
  parent: string;
  type: string;
  index: number;
  resource: string;
  message: string;
  coordX: number;
  coordY: number;
  timestamp: number;
  snapshotThumbnailStorage: string;
  taskType: string;
  duration?: number | null;
  coords?: Record<string, unknown> | null;
}

export const addVideoTask = ({
  parent,
  type,
  index,
  resource,
  message,
  coordX,
  coordY,
  timestamp,
  snapshotThumbnailStorage,
  taskType,
  duration,
  coords,
}: AddVideoTaskParams) => {
  const {
    project: { header },
    user: { identityId },
    workspace: { currentUserGroup },
  } = store.getState();
  const snapshotResourceS3Path = `private/${identityId}/${snapshotThumbnailStorage}`;
  const addVideoTaskInit = {
    headers: header,
    body: `parent=${parent}&type=${type}&index=${index}&resource=${resource}&message=${message}&coord_x=${coordX}&coord_y=${coordY}&timestamp=${timestamp}&preview=${snapshotResourceS3Path}&taskType=${taskType}&duration=${
      duration || null
    }&coords=${coords ? JSON.stringify(coords) : null}`,
  };

  return apiPost(`/task/add?gid=${currentUserGroup}`, addVideoTaskInit);
};

interface EditVideoTaskParams {
  id: string;
  duration?: string;
  status?: string;
  tasktype?: string;
}

export const editVideoTask = ({ id, duration, status, tasktype }: EditVideoTaskParams) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  let body = `id=${id}`;
  if (duration) body += `&duration=${duration}`;
  if (status) body += `&status=${status}`;
  if (tasktype) body += `&taskType=${tasktype}`;

  const updateVideoTaskInit = {
    headers: header,
    body,
  };

  return apiPost(
    `/task/update?gid=${currentUserGroup}`,
    updateVideoTaskInit,
  );
};

export const addTask = (data: Record<string, unknown> & { coords?: Record<string, unknown> | null }) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const { coords, ...rest } = data;

  let body = convertObjectBodyString(rest);
  body = `${body}&coords=${coords ? JSON.stringify(coords) : null}`;

  const addTaskInit = {
    headers: header,
    body,
  };
  return apiPost(`/task/add?gid=${currentUserGroup}`, addTaskInit);
};

export const addAudioTask = (
  parent: string,
  type: string,
  index: number,
  resource: string,
  message: string,
  timestamp: number,
) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const addAudioTaskInit = {
    headers: header,
    body: `parent=${parent}&type=${type}&index=${index}&resource=${resource}&message=${message}&timestamp=${timestamp}`,
  };
  return apiPost(`/task/add?gid=${currentUserGroup}`, addAudioTaskInit);
};

export const getTasks = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const addTaskInit = {
    headers: header,
  };
  return apiGet(
    `/task?gid=${currentUserGroup}&parent=${projectId}`,
    addTaskInit,
  );
};

export const getProjectTasks = (projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const addTaskInit = {
    headers: header,
  };
  return apiGet(
    `/task/all/${projectId}?gid=${currentUserGroup}`,
    addTaskInit,
  );
};

export const addMessageToTask = (taskId: string, message: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const addTaskInit = {
    headers: header,
    body: `id=${taskId}&message=${message}`,
  };
  return apiPost(`/task/message?gid=${currentUserGroup}`, addTaskInit);
};

export const deleteTask = (taskId: string, projectId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const deleteTaskInit = {
    headers: header,
    body: `id=${taskId}&project=${projectId}`,
  };
  return apiPost(`/task/delete?gid=${currentUserGroup}`, deleteTaskInit);
};
